// extracted by mini-css-extract-plugin
export var root = "KMEZ";
export var rootBeige = "I3cX";
export var rootButton = "hCgX";
export var rootButtonActive = "uWqQ";
export var rootButtons = "dFux";
export var rootContent = "zWVY";
export var rootHeading = "_9ZI2";
export var rootItems = "E4Wu";
export var rootSubheading = "+FAX";
export var rootTab = "+ukL";
export var rootTabActive = "sMlb";
export var rootTabs = "F7Vf";
export var rootText = "uGkp";
export var rootWave = "tFPv";